export const MASS_EVENT_END_DATE_TIME = '2025-05-08T00:00:00';
